<style lang="scss">
@media screen and (min-width: 55rem) {
  @font-face {
    font-family: 'PingFang SC','Microsoft YaHei';
    src: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641917677691- 'PingFang SC','Microsoft YaHei'.otf") format("opentype");
  }
  @font-face {
    font-family: 'PingFang SC','Microsoft YaHei';
    src: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641916674528- 'PingFang SC','Microsoft YaHei'.otf") format("opentype");
  }

  .membershipbanner2-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .membershipbanner2 {
      margin-top: 5rem;
      width: 100%;
      height: 21rem;
      background-color: #181a1d;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .membershipbanner2-text {
        width: 40%;
        height: 20%;
        max-width: 780px;
        color: rgb(223, 196, 157);
        font-size: 2.4rem;
        text-align: justify;
        text-align-last: justify;
        font-family:  'PingFang SC','Microsoft YaHei';
      }
      .membershipbanner2-text2 {
        width: 40%;
        height: 20%;
        max-width: 780px;
        font-size: 3rem;
        color: rgb(223, 196, 157);
        text-align: justify;
        text-align-last: justify;
        font-family:  'PingFang SC','Microsoft YaHei';
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .membershipbanner2-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .membershipbanner2 {
      margin-top: 2rem;
      width: 100%;
      height: 21rem;
      background-color: #181a1d;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .membershipbanner2-text {
      width: 80%;
      height: 20%;
      max-width: 780px;
      color: rgb(223, 196, 157);
      font-size: 2.4rem;
      text-align: justify;
      text-align-last: justify;
      font-family:  'PingFang SC','Microsoft YaHei';
    }
    .membershipbanner2-text2 {
      width: 80%;
      height: 20%;
      max-width: 780px;
      font-size: 3rem;
      color: rgb(223, 196, 157);
      text-align: justify;
      text-align-last: justify;
      font-family:  'PingFang SC','Microsoft YaHei';
    }
  }
}
</style>

<template>
  <div class="membershipbanner2-container">
    <div class="membershipbanner2">
      <div class="membershipbanner2-text">升级成为INTIME365会员</div>
      <div class="membershipbanner2-text2">消费享折上9折</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutBanner",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
